'use client';
import warning from 'tiny-warning';

function deprecatedProp(validator, instructions) {
    let warned = false;
    return function validate(props, propName, componentName, location, propFullName, ...args) {
        const componentNameSafe = componentName || '<<anonymous>>';
        const propFullNameSafe = propFullName || propName;
        if (props[propName] != null && !props.__dangerouslySuppressWarning) {
            warning(warned, `The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${instructions}.`);
            if (!warned) console.warn(`${componentNameSafe}: props received =======>`, props);
            warned = true;
        }
        return validator(props, propName, componentName, location, propFullName, ...args);
    };
}

export { deprecatedProp };
